// Экшен ТОЛЬКО для авторизации ТОЛЬКО по номеру телефона
// Если такой номер не авторизован, то падает ошибка PHONE_NOT_REGED
import superagent from '@ott/superagent';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { STATUS_CODES, ERROR_CODES } from '../../../../constants';
import { AuthError, SuperagentError } from '../../types';
import { Payload } from './types';
import { successEvent } from '../../helpers/events';

export const getPinCode = createAsyncThunk<void, Payload, { rejectValue: AuthError }>(
  'auth/getPinCode',
  async ({ phone, reqHost = '' }, { rejectWithValue, fulfillWithValue }) => {
    const url = `${reqHost}/_auth/authenticate/authByPin`;

    try {
      const response = await superagent
        .post(url, { captchaMountContainer: 'auth-by-pin' })
        .type('form')
        .send({ phone })
        .withCredentials();

      const { body } = response;

      if (body && body?.error) {
        return rejectWithValue(body.error);
      }
    } catch (e: any) {
      const err = e as SuperagentError;

      if (err && !err?.response) {
        return rejectWithValue({});
      }

      const { error } = err.response.body;

      switch (err.status) {
        case STATUS_CODES.UNAUTHORIZED:
          if (error === ERROR_CODES.PIN_SENT || error === ERROR_CODES.PHONE_RECENTLY_USED) {
            successEvent('Auth_Popup_Phone_Auth_Click');

            return;
          }
          if (error === ERROR_CODES.PHONE_NOT_REGED) {
            return rejectWithValue({ data: error, status: err.status });
          }
          break;
        default:
          return rejectWithValue({ data: ERROR_CODES.SERVER_ERROR });
      }
    }
  }
);
